import { render, staticRenderFns } from "./Aliens.vue?vue&type=template&id=1a86b8bd&"
import script from "./Aliens.vue?vue&type=script&lang=js&"
export * from "./Aliens.vue?vue&type=script&lang=js&"
import style0 from "./Aliens.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports